(() => {
  // Preserve the app's widget and handlers; only its presentation is collapsed.
  const enhance = () => {
    const widget = document.querySelector('#reviews.fera-productReviews-widget');
    if (!widget || widget.closest('.lennie-reviews')) return false;
    const disclosure = document.createElement('details');
    disclosure.className = 'lennie-reviews';
    const summary = document.createElement('summary');
    summary.textContent = 'Customer reviews';
    widget.before(disclosure);
    disclosure.append(summary, widget);

    const openForHash = () => {
      if (!location.hash) return;
      let target;
      try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); }
      catch { return; }
      if (target && widget.contains(target)) {
        disclosure.open = true;
        target.scrollIntoView({block: 'start'});
      }
    };
    window.addEventListener('hashchange', openForHash);
    // Open before the app's rating-link handler tries to scroll to the widget.
    document.addEventListener('click', event => {
      const source = event.target.closest('a, .fera-productDetailRating-widget');
      if (!source || disclosure.contains(source)) return;
      if (source.matches('.fera-productDetailRating-widget') || source.getAttribute('href') === '#reviews') {
        disclosure.open = true;
      }
    }, true);
    openForHash();
    return true;
  };
  if (enhance()) return;
  const observer = new MutationObserver(mutations => {
    const relevant = mutations.some(mutation => [...mutation.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('#reviews.fera-productReviews-widget') || node.querySelector?.('#reviews.fera-productReviews-widget'))
    ));
    if (relevant && enhance()) observer.disconnect();
  });
  observer.observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
  // A failed/disabled app leaves the normal page untouched, without an idle observer.
  window.setTimeout(() => observer.disconnect(), 15000);
})();
